import type { TimeGranularity } from "app/pages/app-intelligence/types";

import { TableWidget } from "../../TableWidget";
import { geographyColumns } from "../config";

type GeographyItem = { [K in TimeGranularity]: { Average: number; Confidence: number } };

type GeographyResponse = Record<
    number,
    {
        BounceRate: GeographyItem;
        Duration: GeographyItem;
        PagePerVisit: GeographyItem;
        PagesViews: GeographyItem;
        TrafficShare: GeographyItem;
    }
>;

export class SegmentsGeographyGroupWidget extends TableWidget {
    constructor() {
        super();
    }

    static getWidgetMetadataType() {
        return "SegmentsGeographyGroup";
    }

    static getWidgetResourceType() {
        return "Data";
    }

    static getWidgetDashboardType() {
        return "Table";
    }

    public isPptSupported = () => {
        return false;
    };

    public getData() {
        const sid = this._params.segmentId || this._params.keys;
        this._params.sid = sid;

        return super.getData();
    }

    private prepareTableData = (countryData: GeographyItem, granularity: TimeGranularity) => {
        return Object.keys(countryData).reduce((acc, metric) => {
            if (metric !== "TrafficShare") {
                acc[metric] = countryData[metric][granularity]?.Average;
            } else {
                acc[metric] = countryData[metric].Average;
            }

            return acc;
        }, {});
    };

    private transformData(rawResponse: GeographyResponse, granularity: TimeGranularity) {
        const transformedData = { Data: null };

        transformedData.Data = Object.keys(rawResponse).reduce((acc, country) => {
            const tableData = this.prepareTableData(rawResponse[country], granularity);

            acc.push({ ...tableData, Country: country });

            return acc;
        }, []);

        return transformedData;
    }

    public async onNewDataReceived(response: GeographyResponse): Promise<void> {
        const granularity = this._params?.timeGranularity as TimeGranularity;
        const transformedResponse = this.transformData(response, granularity);
        await super.onNewDataReceived(transformedResponse);
    }

    protected getMetricColumnsConfig() {
        return geographyColumns;
    }
}

SegmentsGeographyGroupWidget.register();
